// This is used for collections and search pages.

import { cacheDom } from "../utils/QuerySelectors.js"
import { setupPaginations } from '../components/Pagination.js'

const dom = {}
const qs = {
  section: 'data-products-grid-wrapper',
  plpPaginator: 'data-plp-paginator',
  productsGrid: 'data-products-grid',
  filterPanel: 'data-filter-panel',
  navTop: 'data-plp-nav-top',
  navMain: 'data-plp-nav-main',
  // navQuick: 'data-plp-nav-quick',
  filtered: 'data-plp-filtered',
  visualFilter: 'data-section-type="plp-visual-filter"',
}
const qsAll = {
  facets: 'data-facet',
  filterBtns: 'data-plp-filter-btn',
  clearAlls: 'data-plp-filter-clear-all',
  facetRemoves: 'data-facet-remove',
  vsFilters: 'data-visual-filter',
}
const state = {
  facets: [],
  clearAlls: [],
  filterBtns: [],
  opened: false,
}

const updateOpenedState = (label='') => {
  state.opened = dom.filterPanel.classList.contains('!block')
  dom.navTop.querySelector('[data-plp-filter-btn] .icon-close').classList.toggle('hidden', !state.opened)
  dom.navTop.classList.toggle('lg:!flex', state.opened)
  dom.navTop.classList.toggle('!hidden', state.opened)
  document.body.classList.toggle('cart--opened', state.opened)
  document.body.classList.toggle('overflow-hidden', state.opened)
  if(state.opened && !!label) {
    const target = document.querySelector(`[data-filter-child="${label}"]`)
    if(target) dom.navMain.scrollTo(0, target.offsetTop - (window.innerWidth < 1024 ? 36 : 110))
  }
}

const fetchResults = (url) => {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      dom.plpPaginator.innerHTML = html.querySelector(`[${qs.plpPaginator}]`).innerHTML

      dom.navMain.innerHTML = html.querySelector(`[${qs.navMain}]`).innerHTML
      dom.filtered.innerHTML = html.querySelector(`[${qs.filtered}]`).innerHTML
      // dom.navQuick.innerHTML = html.querySelector(`[${qs.navQuick}]`).innerHTML
      state.facets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`))
      state.facetRemoves = Array.from(document.querySelectorAll(`[${qsAll.facetRemoves}]`))
      state.clearAlls = document.querySelectorAll(`[${qsAll.clearAlls}]`)
      const innerFilterBtns = dom.navMain.querySelectorAll(`[${qsAll.filterBtns}]`)
      innerFilterBtns.forEach(innerFilterBtn => {
        innerFilterBtn.addEventListener('click', (e) => {
          e.stopPropagation()
          dom.filterPanel.classList.toggle('!block')
          updateOpenedState()
        })
      })

      window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
      window.setupApiTiles(dom.plpPaginator)
      initFacets()
      setupPaginations()
    })
}

const renderFilterResults = () => {
  const selectedFacets = state.facets.filter((facet) => facet.checked).map((facet) => `${facet.name}=${encodeURIComponent(facet.value)}`).join('&')
  const filterUrl = `${dom.productsGrid.dataset.productsGrid}?section_id=${dom.productsGrid.dataset.sectionId}&${selectedFacets}`
  fetchResults(filterUrl)
}

const initFacets = () => {
  state.clearAlls.forEach(clearAll => {
    clearAll.addEventListener('click', (e) => {
      e.stopPropagation()
      state.facets.forEach(facet => facet.checked = false)
      renderFilterResults()
    })
  })
  
  state.facets.forEach(facet => facet.addEventListener('input', () => {
    const siblings = document.querySelectorAll(`[name='${facet.getAttribute('name')}'][value='${facet.value}']`)
    siblings.forEach(sibling => {
      if(sibling != facet) sibling.checked = facet.checked
    })
    renderFilterResults()
  }))
  state.facetRemoves.forEach(facetRemove => {
    facetRemove.addEventListener('click', () => {
      const siblings = document.querySelectorAll(`[name='${facetRemove.dataset.name}'][value='${facetRemove.dataset.value}']`)
      siblings.forEach(sibling => sibling.checked = false)
      renderFilterResults()
    })
  })
}

export const setupCollection = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    state.facets = dom.facets
    state.clearAlls = dom.clearAlls
    state.facetRemoves = dom.facetRemoves
    dom.filterBtns.forEach(filterBtn => {
      filterBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        dom.filterPanel.classList.toggle('!block')
        updateOpenedState(filterBtn.getAttribute(qsAll.filterBtns))
      })
    })
    if(dom.filterPanel) {
      dom.filterPanel.addEventListener('click', () => {
        dom.filterPanel.classList.remove('!block')
        updateOpenedState()
      })
    }
    if(dom.navTop) {
      dom.navTop.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    }
    if(dom.navMain) {
      dom.navMain.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    }
    initFacets()

    dom.vsFilters.forEach(vsFilter => {
      vsFilter.classList.toggle('plp-visual-filter--card__active', vsFilter.href == location.href)
      vsFilter.addEventListener('click', (e) => {
        dom.vsFilters.forEach(filter => filter.classList.toggle('plp-visual-filter--card__active', filter == vsFilter))
      })
    })
    if(dom.visualFilter) {
      const swiper = new Swiper(dom.visualFilter, {
        spaceBetween: 12,
        slidesPerView: 'auto',
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        initialSlide: Math.max(0, (dom.vsFilters.filter(vsFilter => vsFilter.classList.contains('plp-visual-filter--card__active'))[0]?.dataset?.index || 0) - 1),
      })
    }
  }
}
